/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<circle
				opacity="0.4"
				cx="12.0001"
				cy="12"
				r="3"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<circle
				cx="12"
				cy="12"
				r="10"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12.0001 15C13.657 15 15.0001 13.6569 15.0001 12C15.0001 10.3431 13.657 9 12.0001 9C10.3433 9 9.00012 10.3431 9.00012 12C9.00012 13.6569 10.3433 15 12.0001 15Z"
				fill="currentColor"
			/>
			<path
				d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M15.0001 12C15.0001 13.6569 13.657 15 12.0001 15C10.3433 15 9.00012 13.6569 9.00012 12C9.00012 10.3431 10.3433 9 12.0001 9C13.657 9 15.0001 10.3431 15.0001 12Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12ZM12.0001 15C13.657 15 15.0001 13.6569 15.0001 12C15.0001 10.3431 13.657 9 12.0001 9C10.3433 9 9.00012 10.3431 9.00012 12C9.00012 13.6569 10.3433 15 12.0001 15Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M16 2.83209C14.7751 2.2969 13.4222 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 9.74835 21.2558 7.67051 20 5.99902M15.0001 12C15.0001 13.6569 13.6569 15 12.0001 15C10.3432 15 9.00006 13.6569 9.00006 12C9.00006 10.3431 10.3432 9 12.0001 9C13.6569 9 15.0001 10.3431 15.0001 12Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M15.0001 12C15.0001 13.6569 13.657 15 12.0001 15C10.3433 15 9.00012 13.6569 9.00012 12C9.00012 10.3431 10.3433 9 12.0001 9C13.657 9 15.0001 10.3431 15.0001 12Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12Z"
				fill="currentColor"
			/>
			<path
				d="M15.0001 12C15.0001 13.6569 13.657 15 12.0001 15C10.3433 15 9.00012 13.6569 9.00012 12C9.00012 10.3431 10.3433 9 12.0001 9C13.657 9 15.0001 10.3431 15.0001 12Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
